<template>
	<div class="fill-height pt-2"  :class="{ 'd-flex align-center justify-center': loading }">
		<div v-if="loading" class="fill-height d-flex flex-column justify-center align-center">
			<div 
				:class="{
					'loader-eye-dark': $vuetify.theme.dark,
					'loader-eye': !$vuetify.theme.dark,
				}"></div>

			<div
				:class="{
					'loader-dark': $vuetify.theme.dark,
					'loader': !$vuetify.theme.dark,
				}"
			></div>
		</div>
		<div v-else class="fill-height pt-2 mb-1" >

			<v-dialog width="350" v-model="dialogAlert">
				<v-card class="rounded-lg pa-1">
					<v-card-title class="pb-2 pt-2 Urbanist-font">
						Alert message
					</v-card-title>
					<v-card-text class="pb-0">	
						Are you sure you want to send today?
					</v-card-text>

					<v-card-actions>
						<v-spacer />
						<v-btn
							class="white--text rounded-lg text-none"
							color="success-light white--text"
							@click="yes = true; updateWorkday()"
						>
							Yes
						</v-btn>
						<v-btn 
							@click="dialogAlert = false"
							class="rounded-lg text-none"
							color="alert-color white--text"
						>
							No
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<!-- <div class="d-flex justify-center align-center">
				<div v-if="!enterTime && !lockDay" class="mb-6 white--text d-flex justify-center align-center card-alert-style" > 
					<v-icon small color="white" class="mx-2"> mdi-alert </v-icon>
					<span>
						Adding enter time please !
					</span>	
				</div>

			</div> -->
			<!-- header -->
			<v-card 
				:style="!$vuetify.theme.dark ? 'box-shadow: -4px 3px 37px -3px #e8e7e76e' : null" 
				class="box  card-style rounded-lg"
			>
				<v-card-text class="pt-0 mt-2 pe-3">
					<v-row align="center" class="">
						<v-col v-if="0" cols="1" class="px-0 py-0">
							<v-img src="../../assets/Vectors/YouDidIt.svg" width="70" contain class="" />
						</v-col>
						<v-col v-if="0" cols="2" align-self="center" class="line-h-1 px-0 py-0">
							<h3 class="Urbanist-font fw-4 text--color mb-1"> you Did it! </h3>
							<span class="Urbanist-font text--color fs-12 fw-5">
								You have completed all your assigned tasks for the day
							</span>
						</v-col>

						<v-col cols="2" class="px-0 py-0 d-flex" align-self="center">
							<v-img :src="startPhoto" width="35" height="70px" contain class="text-center" />
						</v-col>
						<v-col v-if="0" cols="2" align-self="center" class="px-0 py-0">
							<div  class="line-h-1">
								<h3 class="Urbanist-font fw-4 text--color mb-1"> Good job! </h3>
								<span class="Urbanist-font text--color fs-12 fw-5">
									You are more active today than the previous two days
								</span>
							</div>
						</v-col>

						<v-col cols="2" align-self="center" class="py-0 pe-0 d-flex justify-space-between">
							<div class="mx-1">
								<v-img
									v-if="!$vuetify.theme.dark"
									src="../../assets/Vectors/clock-nine (1).svg"
									width="20"
								/>

								<v-img
									v-else
									src="../../assets/Vectors/clock-nine-white.svg"
									width="20"
								/>
							</div>
							<v-divider vertical class="my-0 mx-1 color" /> 
							<v-text-field
								v-model="enterTime"
								label="Enter time"
								type="time"
								hide-spin-buttons
								@change="updateWorkdayForEnterTime()"
								:readonly="lockDay || 
								!(moment(dateWorkDay).isSame(moment(), 'day')) 
								|| !($route.params.id) 
								|| (moment(dateWorkDay).isSame(moment(), 'day') && !$route.params.id) 
								|| (!moment(dateWorkDay).isSame(moment(), 'day') && $route.params.id)
								|| workDay.endDate"
								dense
								class="rounded-lg time"
							/>
						</v-col>

						<v-col cols="2" align-self="center" class="py-0 pe-0 d-flex justify-space-between">
							<div class="mx-1">
								<v-img
									v-if="!$vuetify.theme.dark"
									src="../../assets/Vectors/clock-nine (1).svg"
									width="20"
								/>

								<v-img
									v-else
									src="../../assets/Vectors/clock-nine-white.svg"
									width="20"
								/>
							</div>
							<v-divider vertical class="my-0 mx-1 color" /> 
					
							<v-text-field
								v-model="leaveTime"
								:rules="[val => 
								moment((moment().format('YYYY-MM-DD') + 'T' + val)).isAfter(
									(moment().format('YYYY-MM-DD') + 'T' + enterTime), 'time') || 'Leave time must be later than Enter time']"
								label="Leave time"
								type="time"
								hide-spin-buttons
								@change="updateWorkdayForEnterTime()"
								:readonly="
									lockDay || 
									!(moment(dateWorkDay).isSame(moment(), 'day')) ||
									!($route.params.id) ||
									(moment(dateWorkDay).isSame(moment(), 'day') && !$route.params.id) ||
									(!moment(dateWorkDay).isSame(moment(), 'day') && $route.params.id) ||
									workDay.endDate
								"
								dense
								class="rounded-lg time"
							/>
						</v-col>
						<v-spacer />
						<v-col cols="5" class="d-flex justify-end align-center py-0 pe-0 mt-0 mr-minus-5 ">
							<v-card 
								class="card mx-2 my-1 rounded-lg"
								:class="{
									'bg-secondary': !$vuetify.theme.dark,
									'primary-light': $vuetify.theme.dark
								}"
							>
								<v-card-text>
									<v-row>
										<v-col cols="5" class="py-0 pe-0 ps-3 pe-3">
											<v-img
												:src="pp"
												width="100%"
												height="55"
												contain
												class=""
											/>
										</v-col>
						
										<v-col cols="7" align-self="center" class="px-0 line-h-1-3">
											<h5 
												class="Righteous-font mb-0"
												:class="{
													'primary--text': !$vuetify.theme.dark,
													'white--text': $vuetify.theme.dark
												}"
											> Wishing you </h5>
											<span  
												class="Righteous-font fs-10 fw-7" 
											> 
												a day full of achievement 
											</span>
										</v-col>
									</v-row>
								</v-card-text>
							</v-card>
							<!--  -->
							<v-btn
								small
								color="primary"
								height="80"
								width="100"
								elevation="0"
								class="text-none rounded-r-lg mt-minus-5"
								:to="{ 
									name: 'all-tasks'
								}"
							>
								<div class="d-flex flex-column align-center text-center">
									<v-icon> mdi-arrow-left-thin  </v-icon>
									<span class="line-h-1-3"> Back to <br /> Workdays  </span>
								</div>
							</v-btn>
						</v-col>    
					</v-row>
				</v-card-text>
			</v-card>
			<!-- table -->
			<v-card
				:style="!$vuetify.theme.dark ? 'box-shadow: -4px 3px 37px -3px #e8e7e76e' : null"
				:height="$vuetify.breakpoint.height - 280"
				class="w-100 h-100 rounded-lg mt-4 box"
			>
				<v-card-text class="pb-0 px-0">
					<v-row class="px-4">
						<!-- section one -->
						<v-col align-self="center" cols="4">
							<h4 class="text--color">
								TimeSheet
							</h4>
						</v-col>

						<!-- section two -->
						<v-col cols="4" align-self="center" class="text-center py-1">
							<v-row class="d-flex justify-center">
								<v-col cols="auto" class="px-0">
									<a @click="previous(); getWorkDayByDate()">
										<v-img
											src="../../assets/Vectors/Group 9.png"
											contain
											width="25"
											:disabled="submitLoading"
										/>
									</a>
								</v-col>
								<v-col cols="5" class="px-0">
									<span v-if="isToday" class="mb-0  text--color Righteous-font">
										Today
									</span>
									<span class="fw-4">
										{{ moment(dateWorkDay).format('dddd').slice(0, 3) }}
									</span>
									<span>
										{{ '  ' + moment(dateWorkDay).format('ll')}} 
									</span>
								</v-col>
								<v-col v-if="!isToday" cols="auto" class="px-0">
									<a @click="next(); getWorkDayByDate()">
										<v-img
											src="../../assets/Vectors/Group 9.png"
											contain
											width="25"
											class="reverse-icon"
										/>
									</a>
								</v-col>
							</v-row>
						</v-col>

						<!-- section three -->
						<v-col cols="4" align-self="center">
							<v-row v-if="isToday" justify="end" class="pe-5">
								<v-col cols="auto" align-self="center" class=" ">
									<v-img 
										v-if="!$vuetify.theme.dark" 
										class="" 
										src="../../assets/Vectors/fingerprint.svg" 
										width="20" 
									/>
									<v-img 
										v-else 
										src="../../assets/Vectors/whiteFingerprint.svg" 
										width="30"  
									/>
								</v-col>
								<!-- <v-divider vertical class="me-2 color" />  -->
								<v-col cols="auto" class="line-h-1-3" align-self="center"> 
									<v-row>
										<span 
											class="text--color fs-sm "
										>
											Checked In	
										</span>
									</v-row>
									<v-row>
										<span 
											class="Urbanist-font fw-9 text--color mb-0 fs-15" 
										>  
											{{ moment(workDay.startDate).format('hh:mm: a') }}
										</span>
									</v-row>
								</v-col>
							</v-row>
						</v-col>
					</v-row>

					<v-overlay v-if="0">
						<v-img  src= "../../assets/New folder/Animation - 1728311602469.gif" width="140" height="150" />
						<v-img  src= "../../assets/New folder/Animation - 1728390366576.gif" width="200" height="150" />
					</v-overlay>
					<!-- table -->
					<bee-handy-smart-table
						v-model="tableInputs"
						ref="table"
						:items="tasks"
						:headers="headers"
						class="mt-3"	
						table-class="elevation-0"
						:show-add-row="!lockDay && (tasks.length ? tasks[tasks.length - 1].end : true)"
						@keypress.enter="isEditItem ? editItem() : addItem()"
						zebra
						:height="$vuetify.breakpoint.height - 250"
						editable-rows
						:reset-edit.sync="resetEdit"
						hot-inputs
						@change-end="getDuration()"
						@change-start="getDuration()"
						:loading="submitLoading"
						@change-projectId="getPlannedTask()"
						@change-planId="getData()"
						dense
						fixed-header
						shown-rows-text=""
						:items-per-page="-1"
						hide-default-footer
					>
						<template v-slot:input.projectId="{ on ,attr }">
							<v-autocomplete
								:items="currentUserProjects"
								item-text="name"
								item-value="id"
								dense
								v-on="on"   
								v-bind="attr"
							/>
						</template>

						<template v-slot:input.workFromHome="{ on, attr }">
							<v-checkbox
								v-model="tableInputs.workFromHome"
								v-on="on"
								v-bind="attr"
							/>
						</template>

						<template v-slot:input.planId="{ on ,attr }">
							<v-combobox
								:items="plannedTaskByProject.filter(c => c.isDone === false)"
								item-value="id"
								item-text="content"
								v-on="on"
								v-bind="attr"
								dense
							>
							</v-combobox>
						</template>
							
						<!-- start time -->
						<template v-slot:input.start="{ on, attr }">
							<v-text-field
								type="time" 
								v-on="on"
								v-bind="attr"
							/>
						</template>
								<!-- :rules="[
									val => tasks.length > 0 ?  
										(moment((moment().format('YYYY-MM-DD')+'T'+val)).isSameOrBefore(moment().format('YYYY-MM-DD')+'T'+ (tasks[tasks.length -1].start), 'time')) || 
										moment((moment().format('YYYY-MM-DD')+'T'+val)).isSameOrAfter(moment().format('YYYY-MM-DD')+'T'+ (tasks[tasks.length -1].end), 'time')
									|| 'required' 
									: []
								]" -->

						<!-- end time -->
						<template v-slot:input.end="{ on, attr }">
							<v-text-field
								type="time" 	
								v-on="on"
								v-bind="attr"
							/>
						</template>

						<template v-slot:input.durationInMinute="{ on, attr }">
							<v-text-field
								readonly	
								v-on="on"
								v-bind="attr"
							/>
						</template>

						<template v-slot:input.tags="{ on ,attr }">
							<v-autocomplete
								:items="tags"
								item-text="name"
								item-value="id"
								dense
								v-on="on"   
								v-bind="attr"
								multiple
							/>
						</template>

						<template v-slot:item.actions="{ index, item }">
							<div class="d-flex justify-end">
								<v-btn 
									icon 					
									@click="
										taskId = item.id;
										$refs.table.resetInputs(); 
										$refs.table.activeEditForRow(index); 
										setRowIndex({ index })
									"
									:disabled="
										lockDay || 
										!(moment(dateWorkDay).isSame(moment(), 'day')) 
										|| !($route.params.id) 
										|| (moment(dateWorkDay).isSame(moment(), 'day') && !$route.params.id) 
										|| (!moment(dateWorkDay).isSame(moment(), 'day') && $route.params.id)
										|| Boolean(workDay.endDate)
									"
								>
									<v-img v-if="!$vuetify.theme.dark" src="../../assets/Vectors/pencil.svg" contain width="15" height="23" />
									<v-icon v-else color="edit-color"> mdi-pencil </v-icon>
								</v-btn>

								<v-btn
									v-if="0"
									icon
									@click="taskId = item.id; deleteItem({ index })"
									:disabled="
										lockDay || 
										!(moment(dateWorkDay).isSame(moment(), 'day')) || 
										!($route.params.id) || 
										(moment(dateWorkDay).isSame(moment(), 'day') && !$route.params.id) || 
										(!moment(dateWorkDay).isSame(moment(), 'day') && $route.params.id) ||
										Boolean(workDay.endDate)
									"
								>
									<v-img
										v-if="!$vuetify.theme.dark"
										src="../../assets/Vectors/trash.svg"
										contain
										width="15"
										height="23"
									/>
									<v-icon v-else color="alert-color"> mdi-delete </v-icon>
								</v-btn>
							</div>
						</template>

						<template v-slot:no-input.actions >
							<div class="d-flex justify-end">
								<v-btn
									:color="!isEditItem ? 'success-light': null"
									@click="!isEditItem ? addItem() : $refs.table.resetEdit()"
									class="text-none d-flex justify-end rounded-lg white--text"
									:icon="isEditItem"
								>
									<v-icon small color="white">mdi-{{!isEditItem ? 'plus' : 'close-circle-outline'}}</v-icon>
									{{ !isEditItem ? 'Add Task' : '' }}
								</v-btn>
							</div>
						</template>
					</bee-handy-smart-table>

					<v-row
						v-if="0"
						class="footer primary-light text-end align-item-center rounded-lg rounded-t-0 py-2"
						:class="{
							'primary-light': $vuetify.theme.dark,
						}"
					>
						<v-col align-self="center" class="py-0">
							<span class="Righteous-font text--color mx-3"> Total Hours </span>
							<span class="title text--color fw-bold"> {{ totalHours }} h </span>
						</v-col>
					</v-row>

					<div class="d-flex justify-end">
						<div class="mx-10">
							<span class="Righteous-font text--color mx-3"> Total Hours </span>
							<span class="title text--color fw-bold"> 
								{{								
								Math.floor(totalHours / 60) + ':' + Math.ceil(((totalHours / 60) - Math.floor((totalHours / 60))) * 60).toFixed(0).padStart(2, 0)
								}} 
							</span>
						</div>

						<v-btn
							v-if="lockDay === false"
							@click=" dialogAlert = true"
							small
							:color="totalHours < 6.83 ? 'alert-color white--text' : 'success-light white--text'"
							height="32"
							width="170"
							elevation="0"
							class="text-none rounded-t-0 rounded-b-lg text-end me-11"
						>
							Submit & CheckOut
						</v-btn>
					</div>

					<v-col v-if="0" class="text-end">
						<v-btn
							v-if="lockDay === false"
							@click=" dialogAlert = true"
							small
							:color="totalHours < 6.83 ? 'alert-color white--text' : 'success-light white--text'"
							height="32"
							width="170"
							elevation="0"
							class="text-none rounded-t-0 rounded-b-lg text-end me-11"
						>
							Submit & CheckOut
						</v-btn>
					</v-col>
				</v-card-text>
			</v-card>

		</div>

		<!-- snackbar -->
		<v-snackbar v-model="snackbar" :color="successCloseDay ? 'success' : 'alert-color'">	
			{{ message }}
			<template v-slot:action="{ attrs }">
				<v-btn
					color="white"
					text
					v-bind="attrs"
					@click="snackbar = false"
				>
					Close
				</v-btn>
			</template>
		</v-snackbar>
	</div>
</template>

<script>
import moment from 'moment'
import { mapGetters, mapState } from 'vuex'
import rules from '@/helper/validation rules.js'
export default {
	watch: {
		dateWorkDay (val) {
			let lockDay = false
			if (
				!this.moment(this.workDay.date).isSame(this.moment(), 'day') || 
				(this.moment(this.workDay.date).isSame(this.moment(), 'day') && this.workDay.endDate !== null)
			) {
				lockDay = true
			} else if (
				(this.moment(this.workDay.date).isSame(this.moment(), 'day') && this.workDay.endDate === null)) {
				lockDay = false
			}
			return lockDay 
		},

		'this.tableInputs' (val) {
			console.log(val)
		}
	},

	data () {
		return {
			rules,
			show: false,
			yes: false,
			submitLoading: false,
			dialogAlert: false,
			dateWorkDay: moment(),
			enterTime: null,
			leaveTime: null,
			tasks: [],
			time: moment().format().split('T')[1].split('+')[0],
			taskId: null,
			test: null,
			// myDate: moment(),
			rowEditIndex: null,
			isEditItem: false,
			tableInputs: {
				tagIds: []
			},
			loading: false,
			status: [
				{
					name: 'included',
					id: '0'
				},
				{
					name: 'Not included',
					id: '1'
				}
			],
			resetEdit: false,
			workDay: { tasks: [] },
			snackbar: false,
			message: null,
			showMenu: false,
			text: 'null',
			list: null,
			items: [
				{
					id: '197',
					name: 'test',
					taskno: '12'
				},
				{
					id: '864',
					name: 'tt',
					taskno: '12'
				}
			],
			photos: [
				require('../../assets/New folder/GoodTry.png'),
				require('../../assets/New folder/super.png'),
				require('../../assets/New folder/DidIt.png')
				// require('../../assets/Vectors/Asset 1@3x.png')
			],

			startCardPhoto: [
				require('../../assets/New folder/GoodJob.png'),
				require('../../assets/New folder/GoodDay.png'),
				require('../../assets/New folder/WellDone.png'),
				require('../../assets/Vectors/ShineOn.svg'),
				require('../../assets/New folder/GreatJob.png')
			],

			sentences: [
				'The best version of yourself',
				'The world need you',
				'It is Okay to do things different',
				'You are stronger than you think you are',
				'Small steps are also progress',
				'Focus in your goal'
				// 'The only way to do great work'
			],
			successCloseDay: false
			// lockDay: false
		}
	},
	computed: {
		// ruleStart() {
		// 	// val => tasks.length > 0 ?  
		// 	// 							(moment((moment().format('YYYY-MM-DD')+'T'+val)).isSameOrBefore(moment().format('YYYY-MM-DD')+'T'+ (tasks[tasks.length -1].start), 'time')) || 
		// 	// 							moment((moment().format('YYYY-MM-DD')+'T'+val)).isSameOrAfter(moment().format('YYYY-MM-DD')+'T'+ (tasks[tasks.length -1].end), 'time')
		// 	// 						|| 'required' 
		// 	// 						: []
		// 	return t
		// },
		startPhoto () {
			return this.startCardPhoto[(Math.floor(Math.random() * this.startCardPhoto.length))]
		},
		pp () {
			return this.photos[(Math.floor(Math.random() * this.photos.length))] 
		},
		isToday () {
			return moment().isSame(moment(this.dateWorkDay), 'day')
		},
		...mapState({
			tags: state => state.tags.tags,
			// projectsByUserId: state => state.projects.projectsByUserId,
			employeeId: state => state.auth.self.employeeId,
			currentUserProjects: state => state.projects.currentUserProjects,
			plannedTask: state => state.plan.plannedTask,
			userId: state => state.auth.self.id,
			myPlanActive: state => state.plan.myPlanActive,
			plannedTaskByProject: state => state.plan.plannedTaskByProject
			// users: state => state.users.employees
			// workDayTask: state => state.workDay.workDays
		}),

		...mapGetters({
			getProjectById: 'projects/getProjectById',
			getEmployeeById: 'users/getEmployeeById',
			getTagById: 'tags/getTagById'
			// getProjectByUser: 'projects/getProjectByUser'
		}),

		headers () {
			const headers = [
				// {
				// 	text: '#',
				// 	name: '#',
				// 	value: 'description',
				// 	setValueExpr: (val, index) => {
				// 		return index + 1
				// 	},
				// 	noInput: true,
				// 	width: 'auto'
				// },
				{	
					text: 'Project Name',
					name: 'projectId',
					value: 'projectId',
					setValueExpr: val => this.currentUserProjects.find(c => c.id === val)?.name,
					class: 'text--color',
					inputRules: [val => val !== null || ''],
					sortable: false,
					width: '13%'
				},
				{
					text: 'Description / Plan',
					name: 'planId',
					value: 'description',
					class: 'text--color',
					sortable: false,
					width: '365'
					// inputRules: [val => val !== null || '-']
					// setValueExpr: val => this.plannedTaskByProject.find(c => c.id === val)?.content
				},
				{	
					text: 'Task No',
					name: 'taskNo',
					value: 'taskNo',
					class: 'text--color',
					type: 'number',
					width: '7%',
					sortable: false
				},
				{
					text: 'Start',
					name: 'start',
					value: 'start',
					setValueExpr: val => {
						let start = null
						if (val !== null) {
							if (Number(val.split(':')[0]) > 12 && val !== null) {
								start = (Number(val.split(':')[0]) - 12) + ':' + val.split(':')[1] + ' pm'
							} else if (Number(val.split(':')[0]) <= 12 && val !== null) {
								start = (val.split(':')[0] + ':' + val.split(':')[1] + (Number(val.split(':')[0]) < 12 ? ' am' : ' pm'))
							}
						} else {
							start = '-'
						}
						return start
					},
					inputRules: [
						val => {
							if ((this.tasks.length > 1) || (this.tasks.length === 1 && !this.taskId)) {
								const tasks = this.taskId !== null ? this.tasks.filter(c => c.id !== this.taskId) : this.tasks
								for (let i = 0; i < tasks.length; i++) {
									if (!(moment((moment().format('YYYY-MM-DD') + 'T' + val)).isBefore(moment().format('YYYY-MM-DD') + 'T' + (tasks[i].start), 'time') ||
									moment((moment().format('YYYY-MM-DD') + 'T' + val)).isAfter(moment().format('YYYY-MM-DD') + 'T' + (tasks[i].end), 'time')
									)
									) {
										return 'الفترات الزمنية تتداخل في السطر';
									}
									// }
								}
								return []
							}
						}
					],
					class: 'text--color',
					noNotAvailableText: true,

					width: 120
				},
				{
					text: 'End',
					name: 'end',
					value: 'end',
					setValueExpr: val => {
						let end = null
						if (val !== null) {
							if (Number(val.split(':')[0]) > 12 && val !== null) {
								end = (Number(val.split(':')[0]) - 12) + ':' + val.split(':')[1] + ' pm'
							} else if (Number(val.split(':')[0]) <= 12 && val !== null) {
								end = (val.split(':')[0] + ':' + val.split(':')[1] + (Number(val.split(':')[0]) < 12 ? ' am' : ' pm'))
							}
						} else {
							end = '-'
						}
						return end
					},

					inputRules: [
						val => {
							if (this.tasks.length > 1) {
								if (val) {
									const tasks = this.taskId !== null ? this.tasks.filter(c => c.id !== this.taskId) : this.tasks
									for (let i = 0; i < tasks.length; i++) {
										if (!(moment((moment().format('YYYY-MM-DD') + 'T' + val)).isBefore(moment().format('YYYY-MM-DD') + 'T' + (tasks[i].start), 'time') ||
										moment((moment().format('YYYY-MM-DD') + 'T' + val)).isAfter(moment().format('YYYY-MM-DD') + 'T' + (tasks[i].end), 'time')
										)
										) {
											return 'الفترات الزمنية تتداخل في السطر';
										}
										// }
									}
								} else {
									return []
								}
								return []
							}
						}
					],
					class: 'text--color',
					width: 120,
					noNotAvailableText: true
				},
				{
					text: 'Duration',
					name: 'durationInMinute',
					value: 'durationInMinute',
					setValueExpr: val => {
						if (val > 0) {
							const hoursDifference = val / 60; 
							return `${Math.floor(hoursDifference)}:${Math.ceil((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(0).padStart(2, 0)}`
						} else {
							return val
						}
					},
					class: 'text--color',
					width: 120
					// noInput: true
				},
				{
					text: 'Tags',
					name: 'tags',
					value: 'tagIds',
					setValueExpr: val => val.length ? val.map(c => this.tags.find(i => i.id === c)?.name).join(',') : '-',
					class: 'text--color',
					sortable: false,
					width: '7%'
				},
				{
					text: 'At home',
					name: 'workFromHome',
					value: 'workFromHome',
					setValueExpr: val => val === true ? 'Yes' : 'No',
					class: 'text--color',
					type: 'Boolean',
					sortable: false,
					width: '8%'
				},
				{
					text: '',
					name: 'actions',
					value: 'actions',
					noInput: true,
					sortable: false,
					width: '10%'
				}
			]
			// if (this.tableInputs.status === false) {
			// 	const headerSplice = headers.splice(0, 4).reverse()
			// 	headers.unshift(
			// 		{	
			// 			text: 'Task Description',
			// 			name: 'description',
			// 			value: 'description',
			// 			class: 'text--color',
			// 			width: '13%'
			// 		}
			// 	)
			// 	for (let i = 0; i < headerSplice.length; i++) {
			// 		if (headerSplice[i].name !== 'planId') {
			// 			headers.unshift(headerSplice[i])
			// 		}
			// 	}
			// }
			return headers
		},
		totalHours () {
			return Number(((this.tasks?.map(c => c.durationInMinute).reduce((x, y) => { return (x + y) }, 0))))
		},

		lockDay () {
			let isLockDay = false
			if (
				!this.moment(this.workDay.date).isSame(this.moment(), 'day') || 
				(this.moment(this.workDay.date).isSame(this.moment(), 'day') && this.workDay.endDate !== null)
			) {
				isLockDay = true
			} else {
				isLockDay = false
			}
			// ((this.moment(this.workDay.date).isSame(this.moment(), 'day') && this.workDay.endDate === null))
			return isLockDay
		}
		
	},
	methods: {
		moment,
		next () {
			this.dateWorkDay = moment(this.dateWorkDay).add(1, 'day').format('YYYY-MM-DD');
			return this.dateWorkDay
		},
		previous () {
			this.dateWorkDay = moment(this.dateWorkDay).subtract(1, 'day').format('YYYY-MM-DD')
			return this.dateWorkDay	
		},

		getWorkDayByDate () {
			this.submitLoading = true
			this.$store.dispatch('workDay/fetchSelf', { 
				fromDate: this.moment(this.dateWorkDay).format('MM-DD-YYYY'), 
				toDate: this.moment(this.dateWorkDay).format('MM-DD-YYYY')
			}).then((data) => {
				if (data.length) {
					this.workDay = data[0]
					this.leaveTime = data[0].leaveTime?.split('T')[1]
					this.enterTime = data[0].enterTime?.split('T')[1]
					this.tasks = this.workDay.tasks.map(c => ({ ...c, start: c.start.split('T')[1], end: c.end ? c.end.split('T')[1] : null }))
					if (data.length || this.$route.params.id !== data[0].id) {
						this.$router.push({
							name: 'tasks',
							params: {
								id: data.length ? data[0].id : null
							}
						})
					}
				} else {
					this.tasks = []
					this.enterTime = null
					this.leaveTime = null
				}
			}).finally(() => {
				this.submitLoading = false
			})
		},

		addItem () {
			// console.log(this.moment(this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.start).format().split('+')[0])
			if (this.$refs.table.validate()) {
				this.submitLoading = true
				this.$store.dispatch('tasks/create', { 
					description: this.tableInputs.planId?.content ? this.tableInputs.planId?.content : this.tableInputs.planId,
					projectId: this.tableInputs.projectId,
					taskNo: this.tableInputs.taskNo ? this.tableInputs.taskNo : 0, 
					start: this.tableInputs.start ? this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.start : null,
					end: this.tableInputs.end !== null ? (this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.end) : null,
					planId: this.tableInputs.planId ? this.tableInputs.planId?.id : null,
					durationInMinute: this.tableInputs.durationInMinute ? Math.round((this.tableInputs.durationInMinute) * 60) : 0, 
					workdayId: this.$route.params.id,	
					// isApproved, 
					tagIds: this.tableInputs.tags ? this.tableInputs.tags : [],
					workFromHome: Boolean(this.tableInputs.workFromHome)
				}).then(() => {
					// get workday by id
					this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
						this.workDay = data
						this.tasks = []
						this.tasks = this.workDay.tasks.map(c => ({ 
							...c, 
							start: c.start.split('T')[1], 
							end: c.end ? c.end.split('T')[1] : null
							// durationInMinute: Number(c.durationInMinute.split(':')[0]) * 60 + Number(c.durationInMinute.split(':')[1])
						}))
					}).then(() => {
						this.submitLoading = false
					}).catch(() => {
						this.submitLoading = false
					})
					this.$refs.table.resetInputs();
				})
			}
		},

		editItem () {
			this.submitLoading = true
			this.workDay.tasks[this.rowEditIndex].projectId = this.tableInputs.projectId
			this.workDay.tasks[this.rowEditIndex].taskNo = this.tableInputs.taskNo ? this.tableInputs.taskNo : 0
			this.workDay.tasks[this.rowEditIndex].description = this.tableInputs.description
			this.workDay.tasks[this.rowEditIndex].planId = this.tableInputs.planId
			this.workDay.tasks[this.rowEditIndex].start = (this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.start)
			this.workDay.tasks[this.rowEditIndex].end = (this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.end)
			this.workDay.tasks[this.rowEditIndex].durationInMinute = this.tableInputs.durationInMinute ? Math.round((this.tableInputs.durationInMinute) * 60) : 0

			this.workDay.tasks[this.rowEditIndex].workFromHome = Boolean(this.tableInputs.workFromHome)
			this.workDay.tasks[this.rowEditIndex].tags = this.tableInputs.tags
			this.resetEdit = true
			// this.resetTableInputs()
			this.$refs.table.resetEdit()
			this.isEditItem = false
			this.resetInputsFocus = true
			const start = this.moment().format('YYYY-MM-DD') + 'T' + this.workDay.tasks[this.rowEditIndex].start
			const end = this.moment().format('YYYY-MM-DD') + 'T' + this.workDay.tasks[this.rowEditIndex].end 
			this.$store.dispatch('tasks/update', {
				id: this.taskId, 
				// this.tableInputs.planId ? this.tableInputs.planId : this.tableInputs.planId.content,
				description: this.workDay.tasks[this.rowEditIndex].planId.content ? this.workDay.tasks[this.rowEditIndex].planId.content : this.workDay.tasks[this.rowEditIndex].planId, 
				projectId: this.workDay.tasks[this.rowEditIndex].projectId, 
				taskNo: this.workDay.tasks[this.rowEditIndex].taskNo, 
				planId: this.workDay.tasks[this.rowEditIndex].planId.id, 
				start: moment(start).isSame(end) ? moment(start).add(1, 'minutes') : this.workDay.tasks[this.rowEditIndex].start, 
				end: this.workDay.tasks[this.rowEditIndex].end ? this.workDay.tasks[this.rowEditIndex].end : null, 
				durationInMinute: this.workDay.tasks[this.rowEditIndex].durationInMinute, 
				workdayId: this.workDay.tasks[this.rowEditIndex].workdayId, 
				workFromHome: this.workDay.tasks[this.rowEditIndex].workFromHome, 
				tagIds: this.workDay.tasks[this.rowEditIndex].tags.length ? this.workDay.tasks[this.rowEditIndex].tags : []
				// tagIds: this.tableInputs.tags ? this.tableInputs.tags : [],
			}).then(() => {
				// get workday by id
				this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.workDay = data
					this.tasks = []
					this.tasks = this.workDay.tasks.map(c => ({ ...c, start: c.start.split('T')[1], end: c.end ? c.end.split('T')[1] : null }))
				}).then(() => {
					this.submitLoading = false
				}).catch(() => {
					this.submitLoading = false
				})
			}).catch(() => {
				this.submitLoading = false
			}).finally(() => {
				this.taskId = null
			})
		},

		deleteItem ({ index }) {
			this.loading = true
			this.$store.dispatch('tasks/delete', { id: this.taskId }).then(() => {
				this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.workDay = data
					this.tasks = this.workDay.tasks.map(c => ({ ...c, start: c.start.split('T')[1], end: c.end ? c.end.split('T')[1] : null }))
				})
			}).finally(() => {
				this.loading = false
			})
		},

		setRowIndex (rowData) {
			this.rowEditIndex = rowData.index
			this.isEditItem = true
			this.$nextTick(() => {
				this.$refs.table.resetInputsFocus()
			})
		},

		getDuration () {
			let start = null
			let end = null
	
			start = this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.start
			
			end = this.moment().format('YYYY-MM-DD') + 'T' + this.tableInputs.end
			const hoursDifference = moment(end).diff(start, 'm') / 60;
			this.tableInputs.durationInMinute =
				`${Math.floor(hoursDifference)}:${((hoursDifference - Math.floor(hoursDifference)) * 60).toFixed(0).padStart(2, 0)}`
		},

		updateWorkdayForEnterTime () {
			this.loading = true
			this.$store.dispatch('workDay/update', { 
				id: this.$route.params.id, 
				date: this.workDay.date,
				enterTime: this.enterTime ? this.moment().format('YYYY-MM-DD') + 'T' + this.enterTime : null,
				leaveTime: this.leaveTime ? this.moment().format('YYYY-MM-DD') + 'T' + this.leaveTime : null,  
				startDate: this.workDay.startDate,
				endDate: this.workDay.endDate,
				userId: this.userId,
				notes: '-',
				taskIds: this.tasks.map(c => c.id)
			}).then(() => {
				this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.workDay = data
					this.tasks = []
					this.tasks = this.workDay.tasks.map(c => ({ ...c, start: c.start.split('T')[1], end: c.end ? c.end.split('T')[1] : null }))
					this.enterTime = data.enterTime?.split('T')[1]
					this.leaveTime = data.leaveTime?.split('T')[1]
				})
			}).finally(() => {
				this.loading = false
			})
		},

		updateWorkday () {
			this.loading = true
			this.dialogAlert = false
			this.submitLoading = true
			this.$store.dispatch('workDay/update', { 
				id: this.$route.params.id, 
				// leaveTime: this.moment().format(),
				date: this.workDay.date,
				enterTime: this.workDay.enterTime ? this.workDay.enterTime : null,
				leaveTime: this.leaveTime !== null ? this.moment().format('YYYY-MM-DD') + 'T' + this.leaveTime : null,
				startDate: this.workDay.startDate,
				endDate: this.moment().format().split('+')[0],
				userId: this.userId,
				taskIds: this.tasks.map(c => c.id),
				notes: '-'
			}).then(() => {
				this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.loading = false
					this.submitLoading = false	
					this.snackbar = true
					this.workDay = data
					// this.isLockDay = true
					this.successCloseDay = true
					this.message = 'The day has been successfully closed'
				}).catch(() => {
					this.loading = false
					this.submitLoading = false		
				})
			}).catch(() => {
				this.snackbar = true
				this.message = 'An error occurred, please try again'
			})
		},

		getData () {
			const task = this.plannedTaskByProject.find(c => c.id === this.tableInputs.planId.id)
			if (task) {
				this.tableInputs.taskNo = task?.taskNo
				this.tableInputs.description = task?.content
			}
		},

		getPlannedTask () {
			this.$store.dispatch('plan/fetchPlannedTaskByProject', { projectId: this.tableInputs.projectId }).then((data) => {
				// console.log(this.tableInputs.planId)
				// const task = data.find(c => c.id === this.tableInputs.planId.id)
				// this.tableInputs.taskNo = task?.taskNo
				// this.tableInputs.description = task?.content
				// this.tableInputs.projectId = task?.projectId
			})
		},
		save () {
			this.text = this.items[this.list].name
		}
	},

	created () {
		this.loading = true
		Promise.all([
			this.$store.dispatch('tags/fetchAll').then(() => {
				// console.log(this.tags)
			}),
			this.$store.dispatch('projects/fetchCurrentUserProjects'),
			this.$store.dispatch('plan/fetchActivePlanForUser', { userId: this.userId }).then((data) => {
				if (data.length !== 0) {
					this.$store.dispatch('plan/fetchPlannedTask', { planId: data[0].id })
				}
			}),
			this.$route.params.id 
				? this.$store.dispatch('workDay/fetchById', { id: this.$route.params.id }).then((data) => {
					this.workDay = data
					this.dateWorkDay = data.date
					this.tasks = this.workDay.tasks?.map(c => ({ 
						...c, 
						start: c.start !== null ? c.start.split('T')[1] : null, 
						end: c.end ? c.end.split('T')[1] : null 
					}))
					this.leaveTime = data.leaveTime ? data.leaveTime?.split('T')[1] : null
					this.enterTime = data.enterTime ? data.enterTime.split('T')[1] : null
				})
				: null
		]).finally(() => {
			this.loading = false 
		})
	}
}
</script>

<style scoped>
.fs-12 {
    font-size: 12px;
}
.card {
    width: 250px;
    height: 65px;
}
.w-100 {
    width: 100%;
}
.h-100 {
    height: 100%;
}

.box {
	box-shadow: -4px 3px 37px -3px #e8e7e76e
}
.footer {
	width: 100%; 
	height: 50px; 
	/* background-color: #FBF4DA;  */
	/* padding-right: 10.4rem */
}
.card-alert-style {
	width: 300px; 
	height: 45px; 
	background-color: #e94747;
	border-radius: 7px
}
</style>
<style>
input[type="time"]::-webkit-calendar-picker-indicator { display: none; }
.bee-handy-table--zebra-color:nth-of-type(odd) {
	background-color: #f5ecc966
}
td {
	font-family: 'Urbanist' !important;
}
input:focus {
	border: none !important;
}

</style>

<style>
* {
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

</style>
